import React, { useEffect, useState } from "react";
import "./styles.css";

const STORAGE_KEY = "positions_config";

function ConfigurationPosition() {
  const [positions, setPositions] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [newPosition, setNewPosition] = useState("");

  useEffect(() => {
    const stored = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    setPositions(stored);
  }, []);

  const savePositions = (list) => {
    setPositions(list);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  };

  const addPosition = () => {
    if (!newPosition.trim()) return;

    const exists = positions.some(
      p => p.name.toLowerCase() === newPosition.toLowerCase()
    );
    if (exists) return;

    const updated = [
      {
        name: newPosition.trim(),
        status: "active",
        createdAt: new Date().toISOString()
      },
      ...positions
    ];

    savePositions(updated);
    setNewPosition("");
    setShowModal(false);
  };

  const toggleStatus = (index) => {
    const updated = [...positions];
    updated[index].status =
      updated[index].status === "active" ? "inactive" : "active";
    savePositions(updated);
  };

  return (
    <div className="container">
      <h1>⚙️ Position Configuration</h1>

      {/* TOP ACTION */}
      <div className="top-actions">
        <button className="btn primary" onClick={() => setShowModal(true)}>
          ➕ Add Position
        </button>
      </div>

      {/* TABLE */}
      <div className="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>Position Name</th>
              <th>Status</th>
              <th>Created At</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {positions.map((p, i) => (
              <tr key={i}>
                <td>{p.name}</td>
                <td>
                  <span
                    className={`badge ${
                      p.status === "active" ? "success" : "danger"
                    }`}
                  >
                    {p.status === "active" ? "Active" : "Inactive"}
                  </span>
                </td>
                <td>{new Date(p.createdAt).toLocaleDateString()}</td>
                <td>
                  <span
                    onClick={() => toggleStatus(i)}
                    style={{ cursor: "pointer", fontSize: 20 }}
                    title="Toggle Status"
                  >
                    {p.status === "active" ? "🟢" : "🔴"}
                  </span>
                </td>
              </tr>
            ))}

            {positions.length === 0 && (
              <tr>
                <td colSpan="4" style={{ textAlign: "center", padding: 30 }}>
                  No positions added
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* ADD MODAL */}
      {showModal && (
        <div className="modal">
          <div className="modal-content">
            <div className="modal-header">
              <h2>Add Position</h2>
              <button
                className="close-btn"
                onClick={() => setShowModal(false)}
              >
                ✕
              </button>
            </div>

            <input
              placeholder="Position name"
              value={newPosition}
              onChange={(e) => setNewPosition(e.target.value)}
            />

            <div className="actions">
              <button className="btn ghost" onClick={() => setShowModal(false)}>
                Cancel
              </button>
              <button className="btn primary" onClick={addPosition}>
                Save
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ConfigurationPosition;
